import React from 'react';
import T from 'prop-types';
import styled from 'styled-components';
import WaitSpinner from '@splunk/react-ui/WaitSpinner';
import { toDimension } from '@splunk/visualizations-shared/style';

const WaitSpinnerContainer = styled.div`
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    ${p => toDimension({ width: p.width, height: p.height })};
    font-size: 15px;
`;

/**
 * Loading indicator
 * @param {*} param0
 */
const LoadingIndicator = ({ width, height }) => (
    <WaitSpinnerContainer width={width} height={height} data-test="loading-indicator">
        <WaitSpinner size="medium" />
    </WaitSpinnerContainer>
);

LoadingIndicator.propTypes = {
    /**
     * width in pixel or string, defaults to 100%
     */
    width: T.oneOfType([T.string, T.number]),
    /**
     * height in pixel or string
     */
    height: T.oneOfType([T.string, T.number]),
};
LoadingIndicator.defaultProps = {};
export default LoadingIndicator;
